export default __webpack_public_path__ + "static/media/washingMashinYellow.5c0df0bd.svg";